export default {
  sections: {
    state: {
      title: 'Status',
      fields: {
        pickup_visible: {
          label: 'Afhentning synlig',
        },
        has_pickup: {
          label: 'Afhentning',
        },
      },
    },
    scheduled_orders: {
      title: 'Planlagte bestillinger',
      fields: {
        has_scheduled_orders: {
          label: 'Tillader du, at dine kunder bestiller på forhånd til bestemte tidspunkter?',
        },
        min_schedule_ahead_time_pickup: {
          label: 'Minimumstid (minutter) i forvejen til planlægning af <strong>afhentnings</strong>bestillinger',
          placeholder: '30',
        },
        last_order_gap_pickup: {
          label: 'Seneste tidspunkt for bestilling til <strong>afhentning</strong> (minutter før lukketid)',
          option: '{{value}} min.',
        },
      },
    },
    preparation_time_pickup_orders: {
      title: 'Forberedelsestid for afhentningsbestillinger',
      fields: {
        average_order_preparation_time_min: {
          label: 'Forberedelsestid i minutter',
          placeholder: '20',
        },
        average_order_preparation_time_max: {
          label: 'til',
          placeholder: 'Valgfri',
        },
      },
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    at_least_one_order_method_required:
      'Mindst 1 bestillingsmetode (planlagt eller ASAP) skal være slået til. Du kan ikke deaktivere begge.',
  },
};
